/** @format */

import { Container } from "../../components/layouts/Container";
import OcnkTeikiEconomicEstimateCheckElement from "../../components/ui_elements/ocnkTeiki/Economic/EconomicEstimateCheckElement";

const OcnkTeikiEconomicEstimateCheck = ({ redirect }: { redirect?: boolean }) => {
  return (
    <Container isLogin={true} background={"default"} align={"top"} redirect={redirect}>
      <OcnkTeikiEconomicEstimateCheckElement redirect={redirect} />
    </Container>
  );
};

export default OcnkTeikiEconomicEstimateCheck;
